import { render, staticRenderFns } from "./KoioteDatePicker.vue?vue&type=template&id=f9f56be6"
import script from "./KoioteDatePicker.vue?vue&type=script&lang=js"
export * from "./KoioteDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports